export enum CustomerTypes {
  EXHIBITING_DELEGATE = "exhibitingDelegate",
  CONTRACTOR = "contractor",
  STAFF = "staff",
  VIP = "vipOrBuyersProg"
}
